module.exports = __webpack_public_path__ + "../resources/img/download.33ca9d3e.png";